<template>
  <div class="setting-price one-component-detail-admin">
    <div class="title-component-admin">Liên hệ</div>
    <el-form :model="data" class="p-3">
      <el-form-item label="Số điện thoại">
        <el-input v-model="data.phone" suffix-icon="el-icon-phone"></el-input>
      </el-form-item>
      <el-form-item label="Địa chỉ Email">
        <el-input v-model="data.email" suffix-icon="el-icon-message"></el-input>
      </el-form-item>
      <el-form-item v-if="type === 'tour'" label="Link Booking">
        <el-input v-model="data.booking" suffix-icon="el-icon-link"></el-input>
      </el-form-item>
      <el-form-item v-else label="Website">
        <el-input v-model="data.website" suffix-icon="el-icon-link"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  props: {
    data: Object,
    type: String
  }
}
</script>

<style lang="scss" scoped></style>
